import {observable, computed, action} from 'mobx';

const sortByTimeframeStartDesc = (a, b) => a.timeframe.start < b.timeframe.start ? 1 : -1;
const sortByParentTimeframeStartDesc = (a, b) => a.parent.timeframe.start < b.parent.timeframe.start ? 1 : -1;

export default class {
    constructor() {
        this.isPopulated = false;
        this.people = observable([]);
        this.bySlug = observable(new Map());
    }

    @action async populate() {
        let people = (await (await fetch(__bootstrap.config.apiBaseUrl + 'people')).json());
        for (let i = 0; i < people.length; i++) {
            people[i].$$detailed = false;
        }

        this.people.replace(people);
        this.isPopulated = true;
    }

    @action async fetchBySlug(slug) {
        let person = (await (await fetch(__bootstrap.config.apiBaseUrl + 'people/' + slug)).json());
        person.$$detailed = true;

        const events = [];
        const talks = [];

        const encountered = {
            events: {},
            talks: {},
        };

        if (person.events) {
            for (let event of person.events) {
                if (event.kind === "talk" && !encountered.talks[event.slug]) {
                    talks.push(event);
                    encountered.talks[event.slug] = true;
                }

                if (event.parent === undefined) {
                    if (!encountered.events[event.slug]) {
                        events.push(event);
                        encountered.events[event.slug] = true;
                    }
                } else if (!encountered.events[event.parent.slug]) {
                    // @todo If we ever allow deep schedules in the backend this will need
                    // to become recursive instead.
                    events.push(event.parent);
                    encountered.events[event.parent.slug] = true;
                }
            }

            events.sort(sortByTimeframeStartDesc);
            talks.sort(sortByParentTimeframeStartDesc);

            person.events = events;
            person.talks = talks;
        }

        let i = this.people.findIndex(v => v.slug === slug);

        if (i !== -1) {
            this.people[i] = person
        } else {
            this.people.push(person)
        }

        this.bySlug.set(person.slug, person);

        return person;
    }

    @action flush() {
        this.people = [];
    }
}


// WEBPACK FOOTER //
// ./src/modules/People/Store.js